import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted font-italic lead"
}
const _hoisted_10 = ["innerHTML"]

import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import { tchMarked } from "@common/Common"
    import type { CriterionDetailsDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionDetailsDialog"

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriterionDetailsDialog',
  props: {
        viewModel: {
            type: Object as PropType<CriterionDetailsDialogViewModel>,
            required: true
        }
    },
  setup(__props) {

    const props = __props

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)

    const name = computed(() => vm.value.name)
    const path = computed(() => vm.value.path)
    const description = computed(() => vm.value.description)

    const descriptionHtml = computed(() => tchMarked(description.value))

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(name.value), 1 /* TEXT */),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                  _createElementVNode("small", _hoisted_7, _toDisplayString(path.value), 1 /* TEXT */)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_8, [
                (!description.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, "No description provided"))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", { innerHTML: descriptionHtml.value }, null, 8 /* PROPS */, _hoisted_10)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})